'use client';
import Link from 'next/link';
import React, { useEffect } from 'react';

import { Background } from '@/components/background';
import Logo from '@/components/logo';
import { useStore } from '@/helpers/store';
import { Footer } from '@/modules/footer'; // Add this import
import ReactLenis from 'lenis/react';

const LegalLayout = ({ children }: { children: React.ReactNode }) => {
  const setBackgroundColor = useStore((state) => state.setBackgroundColor); // Add this

  // Reset background color when legal layout mounts
  useEffect(() => {
    setBackgroundColor('white'); // Reset to white
  }, [setBackgroundColor]);

  const lenisConfig = {
    lerp: 0.01,
    duration: 2,
    smoothWheel: true,
  };

  return (
    <ReactLenis root options={lenisConfig}>
      <div>
        <header className="fixed left-5 top-5 p-2.5">
          <Link href="/">
            <Logo fill="fill-at" className="w-[24px] desktop:w-[36px] desktop4k:w-[64px]" />
          </Link>
        </header>
        <main>
          <div className="static-grid min-h-screen pb-[145px] pt-[145px] tablet:pb-[114px] tablet:pt-[114px] desktop:pb-[200px] desktop:pt-[200px]">
            <div className="col-span-full mb-[40px] tablet:mb-[81px] desktop:col-span-10 desktop:col-start-2 desktop:mb-[30px] desktopXL:col-span-10 desktopXL:col-start-2 desktopXL:mb-[44px]">
              {children}
            </div>
          </div>
        </main>
        <Footer />
        <Background />
      </div>
    </ReactLenis>
  );
};

export default LegalLayout;
